import React, { useState, useEffect } from "react";
import { Dropdown, Spinner, Alert } from "react-bootstrap";
import { BsGrid3X3GapFill, BsFillEnvelopeFill } from "react-icons/bs";
import BellIconWithNotifications from "../notifications/notificationwidget";
import { IoMap } from "react-icons/io5";
import { FiRefreshCw } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";

const DataPointsSettings = () => {
  const [dataPoints, setDataPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("accessToken");

  // Fetch all settings on mount
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(
          `${apiUrl}/fetch-renewals-datapoint-settings`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!res.ok) {
          throw new Error(`Error fetching settings: ${res.statusText}`);
        }
        const json = await res.json();
        setDataPoints(
          json.data.settings.map((s) => ({
            Property: s.Property,
            sendToSurefyre: s.sendToSurefyre,
            lastUpdatedBy: s.lastUpdatedBy,
            updatedAt: s.updatedAt,
          }))
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [apiUrl, token]);

  const handleToggle = async (index) => {
    const dp = dataPoints[index];
    const newValue = !dp.sendToSurefyre;

    try {
      const res = await fetch(
        `${apiUrl}/update-renewals-datapoint-settings`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            Property: dp.Property,
            sendToSurefyre: newValue,
          }),
        }
      );
      if (!res.ok) {
        throw new Error(`Update failed: ${res.statusText}`);
      }
      // Update local state
      const updated = [...dataPoints];
      updated[index] = {
        ...dp,
        sendToSurefyre: newValue,
        lastUpdatedBy: "You",
        updatedAt: new Date().toLocaleString("en-GB"),
      };
      setDataPoints(updated);
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) {
    return <Spinner animation="border" variant="primary" />;
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  return (
    <>
      <div className="dashboard-title mb-3 d-flex justify-content-between align-items-center">
        <h1>Data Points</h1>
        <div className="d-flex align-items-center gap-3">
          <BellIconWithNotifications />
          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              id="dropdown-basic"
              className="rounded-circle border-0 bg-transparent"
            >
              <BsGrid3X3GapFill size="1.5rem" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-custom">
              <Dropdown.Item href="/dashboard">
                <BsFillEnvelopeFill className="dropdown-icon" /> Quote/Bind Email
              </Dropdown.Item>
              <Dropdown.Item href="/geographical-concentration">
                <IoMap className="dropdown-icon" /> Geographical Concentration
              </Dropdown.Item>
              <Dropdown.Item href="/renewals-dashboard">
                <FiRefreshCw className="dropdown-icon" /> Renewals
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="content-body">
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th style={{ width: "10%" }}>Status</th>
                <th style={{ width: "40%" }}>Parameter</th>
                <th style={{ width: "25%" }}>Last updated by</th>
                <th style={{ width: "25%" }}>Last updated at</th>
              </tr>
            </thead>
            <tbody>
              {dataPoints.map((dp, idx) => (
                <tr key={dp.Property}>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={dp.sendToSurefyre}
                        onChange={() => handleToggle(idx)}
                      />
                    </div>
                  </td>
                  <td>{dp.Property}</td>
                  <td>{dp.lastUpdatedBy}</td>
                  <td>{dp.updatedAt}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default DataPointsSettings;
